import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

const tableStyle: React.CSSProperties = {
  marginTop: '30px',
  backgroundColor: '#333',
  boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
  borderRadius: '8px',
  overflow: 'hidden',
};

const tableHeadStyle: React.CSSProperties = {
  backgroundColor: '#444',
  color: '#f9d047',
};

const tableRowStyle: React.CSSProperties = {
  borderBottom: '1px solid #555',
};

const tableCellStyle: React.CSSProperties = {
  padding: '12px 15px',
  textAlign: 'left' as 'left',
  fontSize: '16px',
  color: '#f9d047',
};

const Downloads = () => {
  const [checksums, setChecksums] = useState({});
  const [repoFiles, setRepoFiles] = useState<string[]>([]);

  useEffect(() => {
    fetch('/downloads/checksums.json')
      .then(response => response.json())
      .then(data => setChecksums(data))
      .catch(error => console.error('Error fetching checksums:', error));
  }, []);

  useEffect(() => {
    fetch('https://gunthy.org:3009/api/repo-files')
      .then(response => response.json())
      .then(data => {
        const sortedFiles = data.sort((a: string, b: string) => {
          const getVersionNumbers = (filename: string) => {
            const match = filename.match(/(\d+)\.(\d+)\.(\d+)/);
            return match ? match.slice(1).map(Number) : [0, 0, 0];
          };
          const [majorA, minorA, patchA] = getVersionNumbers(a);
          const [majorB, minorB, patchB] = getVersionNumbers(b);

          return (
            majorB - majorA ||
            minorB - minorA ||
            patchB - patchA
          );
        });
        setRepoFiles(sortedFiles);
      })
      .catch(error => console.error('Error fetching repo files:', error));
  }, []);

  return (
    <>
      <Helmet>
        <link rel="canonical" href={'https://www.gunbot.com/downloads/'} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section style={{ backgroundColor: '#1a1a1a' }}>
        <div className="container">
          <div className="row">
            <div className="col text-center">
              <div className="download-links">
                <p className="lead" style={{ marginBottom: '0.5rem' }}>Full Install (includes all necessary libraries and files):</p>
                <a href="/downloads/gunthy_linux.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-terminal" aria-hidden="true"></i> Download for Linux (30.4.3)
                </a>
                <a href="/downloads/gunthy_windows.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-windows" aria-hidden="true"></i> Download for Windows (30.4.3)
                </a>
                <a href="/downloads/gunthy_macos.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-apple" aria-hidden="true"></i> Download for macOS (30.4.3)
                </a>
              </div>

              <div className="download-links">
                <p className="lead" style={{ marginBottom: '0.5rem', marginTop: '2rem' }}>Executable Only (for updating or beta testers):</p>
                <a href="/downloads/beta/gunthy-linux.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-terminal" aria-hidden="true"></i> Download for Linux (Beta v30.4.3)
                </a>
                <a href="/downloads/beta/gunthy-win.exe.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-windows" aria-hidden="true"></i> Download for Windows (Beta v30.4.3)
                </a>
                <a href="/downloads/beta/gunthy-macos.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-apple" aria-hidden="true"></i> Download for macOS (Beta v30.4.3)
                </a>
              </div>

              <div className="download-links">
                <p className="lead" style={{ marginBottom: '0.5rem', marginTop: '2rem' }}>The GUI (Gunbot User Interface):</p>
                <a href="/downloads/beta/gui-linux.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-terminal" aria-hidden="true"></i> GUI for Linux (based on Gunbot v30.3.7)
                </a>
                <a href="/downloads/beta/gui-win.exe.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-windows" aria-hidden="true"></i> GUI for Windows (based on Gunbot v30.3.7)
                </a>
                <a href="/downloads/beta/gui-macos.zip" download className="btn btn-primary m-2" style={{ padding: '15px 30px', fontSize: '18px' }}>
                  <i className="bi bi-apple" aria-hidden="true"></i> GUI for macOS (based on Gunbot v30.3.7)
                </a>
              </div>

              {/* Table showing file names and their checksums */}
              <table className="table" style={{ marginTop: '30px', backgroundColor: '#333' }}>
                <thead>
                  <tr>
                    <th style={{ color: 'rgba(249, 208, 71, 0.7)', borderBottom: '2px solid rgba(249, 208, 71, 0.8)' }}>File Name</th>
                    <th style={{ color: 'rgba(249, 208, 71, 0.7)', borderBottom: '2px solid rgba(249, 208, 71, 0.8)' }}>Checksum</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(checksums).map(([fileName, checksum], index) => (
                    <tr key={index}>
                      <td style={{ color: '#b3b3b3', borderBottom: '1px solid #b3b3b3' }}>{fileName}</td>
                      <td style={{ color: '#b3b3b3', borderBottom: '1px solid #b3b3b3' }}>{checksum as string}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Table showing files in the repo directory */}
              <table className="table" style={tableStyle}>
                <thead style={tableHeadStyle}>
                  <tr>
                    <th style={tableCellStyle}>Old builds</th>
                    <th style={tableCellStyle}>Download</th>
                  </tr>
                </thead>
                <tbody>
                  {repoFiles.map((fileName, index) => (
                    <tr key={index} style={tableRowStyle}>
                      <td style={tableCellStyle}>{fileName}</td>
                      <td style={tableCellStyle}>
                        <a href={`/downloads/repo/${fileName}`} download className="btn btn-secondary">
                          Download
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Downloads;
